/* eslint-disable react-hooks/exhaustive-deps */
import { Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import { ImageCropper } from 'src/reuseableComponents';
import { s3 } from 'src/services/awsS3';
import { getEnvVars } from 'src/utils';
import { v4 as uuidv4 } from 'uuid';

const useStyles = makeStyles(() => ({
  modalWrapper: {
    backgroundColor: 'rgba(0,0,0,0.7)',
  },

  modalCrop: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',

    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%',
    minWidth: '320px',

    '&::-webkit-scrollbar': {
      width: '0px',
    },

    /* Track */
    '&::-webkit-scrollbar-track': {
      margin: '0px',
    },

    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: '#88888852',
    },

    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  },
}));

function ImageCropAwsUploader({ children, cb, resourceType, accept }) {
  const classes = useStyles();
  const [fileData, setFileData] = useState({});
  const [selectedImage, setSelectedImage] = useState('');
  const [croppedImage, setCroppedImage] = useState({});

  const [cloudFrontUrl, setCloudFrontUrl] = useState('');
  const [openImageCropModal, setOpenImageCropModal] = useState(false);

  useEffect(() => {
    if (fileData.name) {
      const reader = new FileReader();
      // it's onload event and you forgot (parameters)
      reader.onload = function(e) {
        setSelectedImage(e.target.result);
        setOpenImageCropModal(true);
      };
      // you have to declare the file loading
      reader.readAsDataURL(fileData);
    }
  }, [fileData]);

  useEffect(() => {
    if (croppedImage && croppedImage.name) {
      uploadToS3();
    }
    // eslint-disable-next-line
  }, [croppedImage]);

  useEffect(() => {
    if (cloudFrontUrl !== '') {
      cb(cloudFrontUrl);
      setOpenImageCropModal(false);
    }
  }, [cloudFrontUrl]);

  const generateS3Config = file => {
    switch (resourceType) {
      case 'testimonial-image':
        return {
          Bucket: getEnvVars().s3BucketTestimonial,
          Key: getEnvVars().s3PathTestimonialImage.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };

      case 'instructor-image':
        return {
          Bucket: getEnvVars().s3BucketInstructor,
          Key: getEnvVars().s3PathInstructorImage.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };

      case 'instructor-resume':
        return {
          Bucket: getEnvVars().s3BucketInstructor,
          Key: getEnvVars().s3PathInstructorResume.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };

      case 'catalogue-syllabus':
        return {
          Bucket: getEnvVars().s3BucketSyllabus,
          Key: getEnvVars().s3PathSyllabus.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };

      case 'catalogue-image':
        return {
          Bucket: getEnvVars().s3BucketCatalogueImage,
          Key: getEnvVars().s3PathCatalogueImage.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };

      default:
        break;
    }
  };

  const generateCloudFrontConfig = () => {
    switch (resourceType) {
      case 'testimonial-image':
        return {
          cloudFrontUrl: getEnvVars().cloudFrontUrlTestimonial,
          fileUrl: getEnvVars().TestimonialFileUrl,
        };

      case 'instructor-image':
        return {
          cloudFrontUrl: getEnvVars().cloudFrontUrlInstructor,
          fileUrl: getEnvVars().InstructorImageFileUrl,
        };

      case 'instructor-resume':
        return {
          cloudFrontUrl: getEnvVars().cloudFrontUrlInstructor,
          fileUrl: getEnvVars().InstructorResumeFileUrl,
        };

      case 'catalogue-syllabus':
        return {
          cloudFrontUrl: getEnvVars().cloudFrounUrlSyllabus,
          fileUrl: getEnvVars().syllabusFileUrl,
        };

      case 'catalogue-image':
        return {
          cloudFrontUrl: getEnvVars().cloudFrontUrlCatalogueImage,
          fileUrl: getEnvVars().catalogueImageFileUrl,
        };

      default:
        break;
    }
  };

  const uploadToS3 = async () => {
    const s3Config = await generateS3Config(croppedImage);
    const { fileUrl, cloudFrontUrl } = await generateCloudFrontConfig();

    s3.upload(s3Config, err => {
      if (err) {
        console.log(err);
      }

      setCloudFrontUrl(
        fileUrl.replace('{cloudFrontUrl}', cloudFrontUrl).replace('{file-path}', s3Config.Key)
      );
    });
  };

  const onDrop = async files => {
    setFileData(files[0]);
  };

  const onImageModalClose = () => {
    setOpenImageCropModal(false);
  };

  const handleCropComplete = cropImage => {
    setCroppedImage(cropImage);
  };

  const handleCancel = () => {
    setOpenImageCropModal(false);
  };

  return (
    <>
      <Dropzone
        onDrop={file => onDrop(file)}
        name="tnc"
        multiple={false}
        minSize={0}
        accept={accept}
      >
        {({ getRootProps, getInputProps }) => (
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            {children}
          </div>
        )}
      </Dropzone>

      <Modal onClose={onImageModalClose} open={openImageCropModal} className={classes.modalWrapper}>
        <div className={classes.modalCrop}>
          <ImageCropper
            image={selectedImage}
            imageName={fileData ? fileData.name : 'noName.jpg'}
            onCropDone={handleCropComplete}
            onCancel={handleCancel}
          />
        </div>
      </Modal>
    </>
  );
}

export { ImageCropAwsUploader };
